import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: 'How much does boat transport cost?',
    a: 'Boat shipping costs typically range from $2 to $5 per mile depending on the size of your vessel, the distance, and the route. We provide transparent, all-inclusive quotes with zero hidden fees. Request a free quote today for exact pricing.'
  }, {
    q: 'How long does shipping a boat take?',
    a: 'Transit times vary based on distance. Generally, a move under 1,000 miles takes 1-3 days, 1,000-2,500 miles takes 3-6 days, and cross-country boat transport over 2,500 miles takes 6-8 days.'
  }, {
    q: 'Is my boat insured during transport?',
    a: 'Yes, absolutely. Every boat transport we handle is fully covered by comprehensive cargo insurance from pickup to delivery, giving you complete peace of mind.'
  }, {
    q: 'How do I prep my boat for transport?',
    a: 'You should secure all loose gear, empty fuel tanks to 1/4 or less, disconnect batteries, remove canvas covers/bimini tops, and ensure the drain plug is removed. We will provide a full preparation checklist when you book.'
  }, {
    q: 'Can you move oversized boats and yachts?',
    a: 'Yes, we specialize in yacht transport and oversized boat movers. We handle all necessary wide-load permits, route surveys, and escort vehicles required for safe delivery.'
  }, {
    q: 'Is a deposit or upfront payment required?',
    a: 'No! Unlike many bidding sites and brokers, we never ask for a deposit or upfront payment before we secure a driver for your boat hauling. You only pay once your transport is scheduled.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-46">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-49">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-50">
            Everything you need to know about our boat hauling services.
          </p>
        </div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-navy" aria-expanded={openIndex === index} data-id="element-53">
                <span className="font-bold text-brand-navy pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>
              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}